import { defineStore } from 'pinia';
import { type Vehicle, type VehiclePosition } from '../domain/vehicle';
import { useEntityStore } from '../../common/composables/entityStore';

export const useVehicleStore = defineStore('vehicles', () => {
  const { add, remove, getById, merge, clear, getOrThrow, list, changed } = useEntityStore<Vehicle>(
    {
      eventName: 'vehicle-changed',
      getEntityId: (e) => e.id,
      updateEntity(dest, src) {
        dest.automaticLogYardMoves = src.automaticLogYardMoves;
        dest.capacity = src.capacity;
        dest.color = src.color;
        dest.description = src.description;
        dest.lastPosition = src.lastPosition;
        dest.name = src.name;
        dest.type = src.type;
        dest.keybinds = src.keybinds;
        dest.lockKeybinds = src.lockKeybinds;
        dest.canMoveFromStorageAreaTypes = src.canMoveFromStorageAreaTypes;
        dest.symbol = src.symbol;
      },
    },
  );

  function updatePosition(vehicleId: string, position: VehiclePosition) {
    const vehicle = getById(vehicleId);
    if (!vehicle) return false;
    vehicle.lastPosition = position;
    changed.emit({
      action: 'updated',
      data: vehicle,
      id: vehicleId,
    });
    return true;
  }

  return {
    add,
    remove,
    getById,
    merge,
    clear,
    getOrThrow,
    vehicles: list,
    changed,
    updatePosition,
  };
});
